import { OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/overview/questionnaireAnswer'

// Amalgamate all subsection questionnaire answer type mappings
export const RESUMPTION_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
